module.exports = __webpack_public_path__ + "static/media/welcome-image.2b993ff7.jpg";